<template>
  <a
    id="lumio-link"
    href="https://lumio.io/"
    rel="noopener noreferrer"
    target="_blank"
  >
    <div class="wrapper">
      <div class="wrapper__item">
        <img alt="lumio" class="img" src="@/assets/banners/lumio-banner.png" />
        <span class="lumio-text">{{ $t('swap.tryLumio') }}</span>
      </div>
      <p-button class="action-button">
        {{ $t('swap.goToLumio') }}
      </p-button>
    </div>
  </a>
</template>
<script></script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 84px;
  padding: 0 5px 0 5px;
  border-radius: 10px;
  backdrop-filter: blur(7.5px);
  background: radial-gradient(
    70% 100% at 5% 50%,
    rgba(112, 36, 70, 0.6) 0%,
    rgba(180, 183, 253, 0.16) 70%
  );
  cursor: pointer;
  overflow: hidden;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  @media (max-width: 500px) {
    gap: 5px;
  }
}
.img {
  margin-left: 10px;
  height: 100%;
  @media (max-width: 500px) {
    margin-left: 5px;
  }
}

.lumio-text {
  font-family: Montserrat, sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 20.72px;
  color: white;
}

.action-button {
  background: rgba(148, 107, 236, 0.1);
  border: 1px solid rgba(148, 107, 236, 1);
  border-radius: 51px;
  padding: 5px 15px;
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: 0;
  text-align: center;

  &:hover {
    background: rgba(148, 107, 236, 0.3);
    border: 1px solid rgba(148, 107, 236, 3);
  }

  &:focus {
    box-shadow: none;
  }

  @media (max-width: 500px) {
    font-size: 10px;
    padding: 6px;
  }
}
</style>
